import '@pbk-web/i18n';

import { systemDefaultLanguageCode } from '@pbk-web/types';
import type { PostProcessorModule } from 'i18next';
import i18next from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

import translations from './i18n-translations';

const debugging = { current: false };

const init = {
  postProcess: ['debugTranslations'],
  interpolation: { escapeValue: false }, // React already does escaping
  lng: systemDefaultLanguageCode,
  fallbackLng: 'en',
  react: {
    useSuspense: true,
  },
};

window.debugTranslations = () => {
  debugging.current = !debugging.current;
  i18next.reloadResources();
  i18next.init(init);
};

const debugTranslationsPlugin: PostProcessorModule = {
  type: 'postProcessor',
  name: 'debugTranslations',
  process: function (value, key, options) {
    if (!debugging.current) return value;

    const { lngs: _, lng: __, keyPrefix: ___, defaultValue: ____, interpolation: _____, ns, ...opts } = options;
    const optsStr = Object.keys(opts).length ? '#' + JSON.stringify(opts) : '';
    let keyStr = Array.isArray(key) ? key.join('.') : key;
    keyStr = keyStr.indexOf(':') === -1 ? keyStr : keyStr.split(':')[1];

    return `[🌍${ns}:${keyStr}${optsStr}]`;
  },
};

let allTranslations = translations;

i18next
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      if (namespace.startsWith('legal-')) {
        return import(`./translations/${language}/${namespace}.md?raw`).then((res) => ({ default: res }));
      }

      const appKey = Object.keys(allTranslations).find((path) => path.includes(`/${language}/${namespace}.json`));
      if (appKey) {
        return allTranslations[appKey]().then((raw) => JSON.parse(raw));
      }

      return { default: {} };
    }),
  )
  .use(initReactI18next)
  .use(debugTranslationsPlugin)
  .init(init);

// Swap in edited translation JSON without a full page reload
if (import.meta.hot) {
  import.meta.hot.accept('./i18n-translations', (mod) => {
    if (!mod) return;
    allTranslations = mod.default;
    // languageChanged makes react-i18next re-render with the reloaded strings
    i18next.reloadResources().then(() => i18next.changeLanguage(i18next.language));
  });
}

export default i18next;
